import { styled } from '@mui/material/styles';
import Section from './Section';
import { FormattedMessage } from 'react-intl';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioButton from '@/components/RadioButton/RadioButton';
import { Volatilities } from '@/constants/Volatilities';

const Volatility = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: [number, number][];
  onChange: (values: [number, number][]) => void;
  mode?: 'light' | 'dark';
}) => {
  const volatilityItems =
    Volatilities.map(({ name, value }) => ({
      id: name,
      value,
    })) || [];

  const groupValue =
    volatilityItems?.find?.(({ value: volatilityValue }) =>
      value.every(
        (v) =>
          volatilityValue[0] === v[0] && volatilityValue[1] === v[1],
      ),
    )?.id || '';

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const volatilityId = (event.target as HTMLInputElement).value;
    const volatilityItem = volatilityItems.find(
      ({ id }) => id === volatilityId,
    );
    onChange([volatilityItem ? volatilityItem.value : [0, 100]]);
  };

  const isDefaultValue =
    value.length === 1 &&
    value[0]?.[0] === 1 &&
    value[0]?.[1] === 6;
  const hasInitialValue = !isDefaultValue;

  return (
    <Section
      title={
        <FormattedMessage
          id="volatility"
          defaultMessage="Volatility"
        />
      }
      aria-label="Volatility filter"
      mode={mode}
      defaultOpen={hasInitialValue}
    >
      <Content>
        <StyledFormControl>
          <RadioGroup
            value={groupValue}
            name="rtp"
            onChange={handleChange}
          >
            {volatilityItems.map(({ id }) => (
              <FormControlLabel
                key={id}
                value={id}
                control={<RadioButton mode={mode} />}
                label={id}
                aria-label={`Select ${id} volatility`}
              />
            ))}
          </RadioGroup>
        </StyledFormControl>
      </Content>
    </Section>
  );
};

const Content = styled('div')({
  display: 'block',
  height: '180px',
});

const StyledFormControl = styled(FormControl)({
  display: 'block',
  height: '180px',
  maxHeight: '180px',
  overflowY: 'auto',
});

export default Volatility;
